import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import http from 'services/http';
import { alerta } from 'components/Alert/index';
import Pagination from 'components/Paginacao';
import 'components/Paginacao/style.css';

const pageSize = 20; // mesmo valor do backend (paginate(20))

export default function Supervisores(props) {
    const [supervisores, setSupervisores] = useState([]);
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let ativo = true;
        const carregar = async () => {
            setLoading(true);
            try {
                const { data: { data: paginator } } = await http.get('/supervisores', {
                    params: { page: currentPage },
                });
                if (!ativo) return;
                setSupervisores(paginator.data ?? []);
                setTotal(paginator.total ?? 0);
            } catch (e) {
                if (ativo) alerta(e.response?.data ?? { success: false, message: 'Erro ao listar gerentes.' });
            } finally {
                if (ativo) setLoading(false);
            }
        };
        carregar();
        return () => { ativo = false; };
    }, [currentPage]);

    const recarregar = () => {
        // força recarga mantendo a página atual
        setCurrentPage((p) => p);
        setLoading(true);
        http.get('/supervisores', { params: { page: currentPage } })
            .then(({ data: { data: paginator } }) => {
                setSupervisores(paginator.data ?? []);
                setTotal(paginator.total ?? 0);
            })
            .catch((e) => alerta(e.response?.data ?? { success: false, message: 'Erro ao listar gerentes.' }))
            .finally(() => setLoading(false));
    };

    const excluir = (supervisor) => {
        Swal.fire({
            title: 'Excluir gerente?',
            text: `"${supervisor.nome}" deixará de aparecer nos filtros. Os gerentes e relatórios não são afetados.`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            reverseButtons: true,
            confirmButtonText: 'Sim, excluir',
            cancelButtonText: 'Cancelar',
        }).then(async (result) => {
            if (!result.value) return;
            try {
                const response = await http.delete(`/supervisores/${supervisor.id}`);
                alerta(response.data);
                recarregar();
            } catch (e) {
                alerta(e.response?.data ?? { success: false, message: 'Erro ao excluir gerente.' });
            }
        });
    };

    const mudarPagina = (page) => {
        setCurrentPage(page);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <>
            <div className="titulo-principal d-flex justify-content-between align-items-center">
                <span>Grupo Gerentes</span>
                <button
                    type="button"
                    className="btn btn-sm btn-success"
                    onClick={() => props.history.push('/supervisores/novo')}
                >
                    Novo Gerente
                </button>
            </div>

            <div className="conteudo-principal p-0">
                {loading ? (
                    <div className="p-4 text-center">Carregando...</div>
                ) : (
                    <table className="table table-sm text-center border mb-0 align-middle">
                        <thead className="thead-light">
                            <tr>
                                <th>Nome</th>
                                <th>Gerentes vinculados</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {supervisores.length === 0 ? (
                                <tr>
                                    <td colSpan="3" className="text-muted p-4">Nenhum gerente cadastrado.</td>
                                </tr>
                            ) : supervisores.map((s) => (
                                <tr key={s.id}>
                                    <td className="text-left" style={{ fontWeight: 600 }}>{s.nome}</td>
                                    <td className="text-left" style={{ whiteSpace: 'normal' }}>
                                        {(s.gerentes ?? []).length === 0 ? (
                                            <span className="text-muted">—</span>
                                        ) : s.gerentes.map((g) => (
                                            <span key={g.id} className="badge badge-info mr-1 mb-1" style={{ fontSize: '0.8rem' }}>
                                                {g.nome ?? g.login}
                                            </span>
                                        ))}
                                    </td>
                                    <td style={{ whiteSpace: 'nowrap' }}>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary mr-1"
                                            onClick={() => props.history.push(`/supervisores/${s.id}/editar`)}
                                        >
                                            Editar
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-danger"
                                            onClick={() => excluir(s)}
                                        >
                                            Excluir
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}

                {!loading && total > pageSize && (
                    <div className="d-flex justify-content-center py-2">
                        <Pagination
                            currentPage={currentPage}
                            totalCount={total}
                            pageSize={pageSize}
                            onPageChange={mudarPagina}
                        />
                    </div>
                )}
            </div>
        </>
    );
}
